<template>
    <div>
        <cityinfo-header></cityinfo-header>
        <div class="inner-banner">
            <section class="w3l-breadcrumb">
                <div class="container py-md-4">
                    <div class="title-heading-w3 text-center mx-auto">
                        <h3 class="title-main" >{{model.title}}</h3>
                        <div class="row mt-4 sub-title">
                            <div class="col-md-3">
                                <label class="col-5">發佈單位:</label>
                                <span class="col-7">{{model.publisherDept}}</span>
                            </div>
                            <div class="col-md-3">
                                <label class="col-5">發佈人:</label>
                                <span class="col-7">{{model.publisher}}</span>
                            </div>
                            <div class="offset-md-3 col-md-3 form-inline">
                                <label class="col-5">發佈時間:</label>
                                <div class="col-7" style="padding-right:0px;">{{model.createDate ? customFormatter(model.createDate, "YYYY/MM/DD HH:mm:ss"):""}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="w3l-contacts-12">
                <div class="contact-top pt-5">
                    <div class="container py-md-4 py-3">
                        <div class="cont-main-top mt-5" style="grid-template-columns: none;">
                            <div class="contacts12-main ml-lg-4 mr-lg-4 value-context" v-if="model.contentValue" v-html="htmlDecode(model.contentValue)">
                            </div>
                            <div class="row mt-md-5 mt-3">
                                <div class="col-md-12 left-insp-art">
                                    <ul>
                                        <li v-for="(item, i) in files" :key="i">
                                            <i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>
                                            <a href="javascript:;" @click="downloadPFile(item)">{{item.fileName}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mt-md-5 mt-3">
                                <div class="col-12 text-center">
                                    <div class="btn btn-style">
                                        <button type="button" class="btn" @click="$router.go(-1);">返回</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    props:["id"],
    components:{
        "cityinfo-header":header,
        "cityinfo-footer":footer
    },
    data(){
        return {
            model:{},
            files:[],
        }
    },
    mounted(){
        window.scrollTo(0,0);
        if(this.getStore(this.$route.name)){
            let param = JSON.parse(this.getStore(this.$route.name));
            this.$http.post(`/api/Proclamation/${param.id}`).then(a => {
                this.model = a.body.value;
                this.files = a.body.files;
            });
        }
    },
    methods:{
        downloadPFile(obj){
            this.$http.post("/api/Share/fileDownload",JSON.stringify({
                model:obj.filePath,
            }),{
                headers: { "Content-Type": "application/json" },
                responseType: "blob" 
            }).then(res => {
                this.downloadFile(res.body, obj.fileName);
            }).catch(err => {
                console.log(err);
            });
        },
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>
<style>
.contacts12-main img {
    max-width: 100%;
}
.value-context > *{
    margin: revert;
    padding: revert;
}
.value-context > * > li{
    list-style-type:revert;
}
</style>